import api from '../../../actions/api.actions'
import { ENV_LOWER_ENV, ENV_HIGHER_ENV, CRYPTOTYPE } from '../../utils/constant'

export default class configurationService {
  initialConfiguration = {
    environment: process.env.VUE_APP_ADMIN_KEYS_ENV === 'production' ? ENV_HIGHER_ENV.Sandbox : ENV_LOWER_ENV.Stage,
    sdkJsUrl: '',
    idToken: '',
    checkout: {
      srcClientId: '',
      srcDpaId: '',
      dpaLocale: '',
      srciTransactionId: ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, a => (a ^ Math.random() * 16 >> a / 4).toString(16)),
      cryptoType: CRYPTOTYPE[Object.keys(CRYPTOTYPE)[0]],
      srcConsumerKey: '',
      pemKey: '',
      payloadRequestUrl: '',
      confirmationRequestUrl: '',
      encKey: ''
    },
    returningUser: {
      validationData: null,
      consumerAuthorization: null
    },
    cardEncKey: ''
  }
  /**
   * Get list of environments
   * @returns {*|Promise<T | never>}
   */
  getEnvironments () {
    return api.getEnvironments()
  }

  /**
   * Get api config end points based on environment
   * @param environmentId
   * @returns {*|Promise<T | never>}
   */
  getApiEndPoints (environmentId) {
    return api.getApiEndPoints(environmentId)
  }

  /**
   * Get SRC Keys based on environment
   * @param environment
   * @returns {*|Promise<T | never>}
   */
  getSrcKeys (environment) {
    return api.getSrcKeys(environment)
  }

  /**
   * Get Default config data
   * @returns {dynamicDataTypeAmex: *, enableConfirmation: boolean, advanced: {cofDigitalCardId: string, cofSrciTxId: string, paymentProcessorPassword: null, paymentProcessorUsername: null, checkoutBtnUrl: *}, dynamicDataTypeVisa: *, jwtOnOff: *, dynamicDataTypeMastercard: *, isSRCCheckoutDisabled: null, tokenization: {validityPeriodMinutes: number, dynamicCVC2Support: boolean, cryptoFormat: []}, environment: *, cofOnOff: *, federatedID: {jwtPayload: string}, storefront: {currency: string, locale: string, quickCart: {totalPrice: number, products: {quantity: number, productId: *, price: number}[]}}, checkout: {payloadRetrievalPreference: [*], originUrl: string, srcEntityIds: {srci: *[], dpaConfigs: *[], environmentId: string, mttConfigId: string, displayName: string, index: number}[], shippingAddress: *, billingCountryCodes: null, dsaTransactionOptions: {consumerEmailAddressRequested: boolean, consumerNameRequested: boolean, consumerPhoneNumberRequested: boolean}, billingAddress: *, shippingCountryCodes: null, dpaIds: *[]}}
   */
  getConfigData () {
    const configDetails = JSON.parse(localStorage.getItem('MCSDKTestToolDetails'))
    if (configDetails) {
      return configDetails
    }
    return this.initialConfiguration
  }

  /**
   * set config data state
   * @param configState
   */
  setConfigData (configState) {
    localStorage.setItem('MCSDKTestToolDetails', JSON.stringify(configState))
  }

  setConfigDataOnEnvironment (environment) {
    const data = this.getConfigData()
    data.environment = environment
    this.setConfigData(data)
  }

  /**
   * Get selected config data based on environment
   * @returns {string}
   */
  getConfigDataOnEnvironment () {
    return this.getConfigData().environment
  }

  getSignatureHeader (requestBody) {
    return api.getSignatureHeader(requestBody)
  }

  getCheckoutResponseJWS (requestBody) {
    return api.getCheckoutResponseJWS(requestBody)
  }

  getConfirmationApiResponse (requestBody) {
    return api.getConfirmationApiResponse(requestBody)
  }
}
